module.exports = __webpack_public_path__ + "static/media/SparksSq.00a04dc7.jpg";